<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-header">
                    <div class="discardContainer">
                        <div style="display: flex; justify-content: space-between">
                            <div class="title">{{title ?? 'Are you sure?'}}</div>
                            <img alt="img" class="pointer" @click="onCloseClick" src="../assets/crossIcon.svg" />
                        </div>
                        <div class="subtitle">{{subTitle ?? 'Discard will permanantly delete any changes made to this form'}}</div>
                        <div v-if="leftButton || rightButton" class="btns"> 
                            <div class="cancelBtn" @click="onCloseClick">{{leftButton}}</div>
                            <div class="discardBtn" @click="onButtonClick">{{rightButton}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ConfirmationModal',
        props: {
            leftButton: String,
            rightButton: String,
            warnMessage: String,
            title: String,
            subTitle: String,
         },
        methods: {
            onCloseClick(){
                this.$emit('cancelClicked')
            }, 
            onButtonClick(){
                this.$emit('buttonClicked')
            }
        }
    }
</script>

<style scoped>

    .discardContainer{
        max-width: 1189px;
        margin: 0 auto;
        text-align: center;
        padding: 16px 30px 30px;
        width: 308px;
        background: #FFFFFF;
        border-radius: 12px;
    }
    .title{
        font-weight: 700;
        font-size: 18px;
        line-height: 25px;
        text-align: center;
        color: #333333;
        margin: 24px 0 16px;
    }

    .subtitle{
        font-weight: 400;
        font-size: 16px;
        line-height: 21px;
        text-align: left;
        color: #666666;
        margin-bottom: 32px;
    }

    .btns{
        display: flex;
    }

    .cancelBtn{
        border: 1px solid #2E31BE;
        border-radius: 4px;
        padding: 12px 42px;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        color: #2E31BE;
        cursor: pointer;
        margin-right: 20px;
    }

    .discardBtn{
        background: #2E31BE;
        border-radius: 4px;
        padding: 12px 42px;
        font-weight: 700;
        font-size: 14px;
        line-height: 17px;
        text-align: center;
        color: #FFFFFF;
        cursor: pointer;
        width: 50px;
    }
    .pointer {
        cursor: pointer;
    }


    .modal-mask {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
        transition: opacity 0.3s ease;
    }

    .modal-wrapper {
        display: table-cell;
        vertical-align: middle;
    }
    .modal-container {
        width: 300px;
        margin: 0px auto;
        padding: 20px 30px;
        border-radius: 2px;
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
    }

    .modal-header h3 {
        margin-top: 0;
        color: #42b983;
    }

    .modal-body {
        margin: 20px 0;
    }
    .modal-default-button {
      float: right;
    }
    .modal-enter-from, .modal-leave-to {
        opacity: 0;
    }
    .modal-enter-active .modal-container,
    .modal-leave-active .modal-container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

</style>